import axios from "axios";
import { GENERAL_URL_API } from "../urls";

/**
 * Lista las editoriales visibles para el usuario.
 * @returns {Promise<Array>} Editoriales con `nombre` y `paisEditorial`, entre otros campos.
 */
export async function fetchEditoriales() {
  const { data } = await axios.post(
    `${GENERAL_URL_API}/verDatos/verEditoriales.php`,
    new FormData(),
    { withCredentials: true }
  );

  return data?.data ?? [];
}
